import { render, staticRenderFns } from "./crop_consult.vue?vue&type=template&id=cf9b4996&"
import script from "./crop_consult.vue?vue&type=script&lang=js&"
export * from "./crop_consult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports